// extracted by mini-css-extract-plugin
module.exports = {"card":"WorkoutCard_card__1dYlA","artifacts":"WorkoutCard_artifacts__1tADa","blockLink":"WorkoutCard_blockLink__1NpkC"};